import useTeamContext from '@maxpreps/shared/contexts/TeamContext';
import { SITE_NAV_BREAK_POINT } from '@maxpreps/shared/corecomponents/SiteNav/SiteNavUtils';
import useIsAdmin from '@maxpreps/shared/hooks/useIsAdmin';
import { useIsScreenSize } from '@maxpreps/shared/hooks/useIsScreenSize';
import StyledButton, {
  ButtonFill,
  ButtonTheme
} from '@maxpreps/shared/ui/Button/StyledButton';
import React from 'react';
import TeamSmartAnchor from '../TeamSmartAnchor';
import { getTeamUrl } from './../../../utils/navigation';
import { Page } from './../../../utils/pages';

const AdminHeaderButton: React.FC<{
  page: Page;
  publicPageKey: Page | undefined;
  adminPageKey: Page | undefined;
}> = ({ page, publicPageKey, adminPageKey }) => {
  const isDesktop = useIsScreenSize(SITE_NAV_BREAK_POINT);
  const isAdminPage = useIsAdmin();
  const teamContext = useTeamContext();

  const { data, mostRecentPublicGenderSportSeasonLevel, teamSeasonPickerData } =
    teamContext;

  let { canonicalUrl, sportSeasonId } = data;

  let text: string;
  let calculatedPage = page;
  const queryString: { admin?: number } = {};

  if (isAdminPage) {
    text = 'Public';

    // must check like this because publicPageKye can be '' for the home page
    if (typeof publicPageKey === 'string') {
      calculatedPage = publicPageKey;
    }

    // if we are on an admin page in an unpublished sport season context
    // make sure to use the most recent published sport season
    if (
      !teamSeasonPickerData.find(ss => ss.sportSeasonId == sportSeasonId)
        ?.isPublished
    ) {
      canonicalUrl = mostRecentPublicGenderSportSeasonLevel.canonicalUrl;
      sportSeasonId = mostRecentPublicGenderSportSeasonLevel.sportSeasonId;
    }
  } else {
    text = 'Admin';

    queryString.admin = 1;

    if (typeof adminPageKey === 'string') {
      calculatedPage = adminPageKey;
    }
  }

  const href = getTeamUrl(calculatedPage, canonicalUrl, queryString);

  return (
    <TeamSmartAnchor
      href={href}
      ssid={sportSeasonId}
      visualComponent={StyledButton}
      visualComponentProps={{
        $fillMode: isAdminPage ? ButtonFill.Outline : ButtonFill.Fill,
        $colorScheme: ButtonTheme.White
      }}
    >
      {isDesktop ? `Go to ${text}` : text}
    </TeamSmartAnchor>
  );
};

export default AdminHeaderButton;
